import { LevelDesignerElementBase } from '../elements/element-base';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';
import { Tool, ToolType } from './tool';
import { ToolGroup } from './tool-group';

export class LevelDesignerLockTool extends Tool {
    private lockState: 'locked' | 'unlocked' | 'mixed' | 'disabled' = 'disabled';
    private selectedElements: LevelDesignerElementBase[] = [];

    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, ToolType.Toggle, 'assets/icons/lock.svg');
    }

    public override getName(): string {
        return 'Lock';
    }

    public override getTooltip(): string {
        return 'Lock/Unlock Selected Elements';
    }

    public override getIconPath(): string {
        // Return different icons based on state
        switch (this.lockState) {
            case 'locked':
                return 'assets/icons/lock.svg';
            case 'unlocked':
                return 'assets/icons/lock_open.svg';
            case 'mixed':
                return 'assets/icons/lock_mixed.svg';
            default:
                return 'assets/icons/lock.svg';
        }
    }

    override onActivated(): void {
        this.toggleLock(this.selectedElements[0]);
    }

    onClick(x: number, y: number): void {
        //do nothing when an element is clicked
    }

    onKeyPress(key: string): void {
        if (key === 'l' || key === 'L') {
            this.levelDesigner.selectedElements.forEach(e => this.toggleLock(e));
        }
    }

    public override onSelectionChanged(selectedElements: LevelDesignerElementBase[]): void {
        this.selectedElements = selectedElements;
        this.updateLockState();
    }

    public override getButtonWidth(): number {
        return 40; // Custom width for LockTool
    }

    private updateLockState(): void {
        if(this.selectedElements.length === 0) {
            this.lockState = 'disabled';
            return;
        }
        const lockedCount = this.selectedElements.filter(e => e.isLocked()).length;
        if (lockedCount === 0) {
            this.lockState = 'unlocked';
        } else if (lockedCount === this.selectedElements.length) {
            this.lockState = 'locked';
        } else {
            this.lockState = 'mixed';
        }
        console.log("Lock state: " + this.lockState);
    }

    private toggleLock(element: LevelDesignerElementBase): void {
        const newLockState = !this.selectedElements[0].isLocked();
        this.selectedElements.forEach(element => {
            element.setLocked(newLockState);
        });
        this.updateLockState();
        this.levelDesigner.saveState();
    }
}
